import serverCall from "../serverCall";

const getUsers = async (params = {}) => {
  try {
    const { page = 1, limit = 10, ...otherParams } = params;

    const queryParams = {
      page: page.toString(),
      limit: limit.toString(),
      ...otherParams,
    };

    const response = await serverCall.get(`admin/users`, {
      params: queryParams,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getUserById = async (userId) => {
  try {
    const response = await serverCall.get(`admin/users/${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const createUser = async (userData) => {
  try {
    const response = await serverCall.post(`admin/users`, userData);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateUser = async (userId, userData) => {
  try {
    const response = await serverCall.put(`admin/users/${userId}`, userData);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteUser = async (userId) => {
  try {
    const response = await serverCall.delete(`admin/users/${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const toggleUserActive = async (userId) => {
  try {
    const response = await serverCall.patch(
      `admin/users/${userId}/toggle-active`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getUserJobs = async (params = {}) => {
  try {
    const { userId, page = 1, limit = 10, ...otherParams } = params;

    const queryParams = {
      userId,
      page: page.toString(),
      limit: limit.toString(),
      ...otherParams,
    };

    const response = await serverCall.get(`admin/users/get-user-jobs`, {
      params: queryParams,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const UserService = {
  getUsers,
  getUserById,
  createUser,
  updateUser,
  deleteUser,
  toggleUserActive,
  getUserJobs,
};

export default UserService;
